module.exports = __webpack_public_path__ + "media/assets_v3/images/gamesatis-avatar-b5154f951d98c5d7f87b7462d7a99d4a.png";